module.exports = __webpack_public_path__ + "static/img/live-to-learn__small.e667db4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyTour/img/primary/live-to-learn__small.jpg
// module id = tD8A
// module chunks = 1